<template>
	<IconAutoDirection :icon="icon" />
</template>

<script>
import { ref } from 'vue';
import { LoginOutlined } from '@ant-design/icons-vue';
import IconAutoDirection from '@/components/menu/IconAutoDirection.vue';

export default {
	components: {
		IconAutoDirection,
	},
	setup() {
		const icon = ref(LoginOutlined);
		return {
			icon,
		};
	},
};
</script>
